// Главный экран, согласие при первом запуске, «кому» и «повод» для подарка.

import { useState } from 'react';
import { api } from '../lib/api.ts';
import { useApp } from '../lib/store.tsx';
import { haptic } from '../lib/tg.ts';
import { track } from '../lib/events.ts';
import { onSite } from '../lib/web.ts';
import { Flower, Icon, Sheet, StepTop, ErrorNote } from '../ui/kit.tsx';

let consentDismissed = false;

export function Main() {
  const { go, startFlow, me, reloadMe } = useApp();
  const [showConsent, setShowConsent] = useState(true);
  const active = me?.orders.find((o) => !['delivered', 'cancelled', 'unpaid'].includes(o.status));
  // На сайте согласие даётся при оформлении (галочка), отдельного окна нет.
  const needConsent = Boolean(!onSite && me && !me.user.consentPd && showConsent && !consentDismissed);

  return (
    <main className="screen" style={{ paddingTop: 28, gap: 24 }}>
      <svg className="blob" aria-hidden="true" viewBox="0 0 40 40" style={{ right: -70, top: -60, width: 220, height: 220, opacity: 0.55 }}>
        <g fill="#FEEB9E">
          <circle cx="20" cy="10" r="7.5" />
          <circle cx="29.5" cy="16.9" r="7.5" />
          <circle cx="25.9" cy="28.1" r="7.5" />
          <circle cx="14.1" cy="28.1" r="7.5" />
          <circle cx="10.5" cy="16.9" r="7.5" />
          <circle cx="20" cy="20" r="8" />
        </g>
      </svg>
      <div className="row" style={{ justifyContent: 'space-between', alignItems: 'flex-start', position: 'relative' }}>
        {onSite ? (
          <a href="/" aria-label="На главную сайта">
            <img src="/logo.png" alt="Выдыхай" style={{ width: 170, height: 'auto', marginLeft: -12, mixBlendMode: 'multiply' }} />
          </a>
        ) : (
          <img src="/logo.png" alt="Выдыхай" style={{ width: 190, height: 'auto', marginLeft: -12, mixBlendMode: 'multiply' }} />
        )}
        {onSite ? (
          <button type="button" className="btn light sm" style={{ minHeight: 44, fontSize: 14, padding: '0 14px' }} onClick={() => go({ name: 'myOrders' })}>
            Мои заказы
          </button>
        ) : (
          <button type="button" className="iconbtn" aria-label="Профиль: заказы, люди и даты" onClick={() => go({ name: 'profile' })}>
            <Icon name="user" />
          </button>
        )}
      </div>
      <div className="stack" style={{ position: 'relative' }}>
        <h1 className="h1 big">Выдыхай, букет подберём мы</h1>
        <p className="lead">Пара вопросов и несколько свайпов. В конце покажем три букета, которые подходят лучше всего.</p>
      </div>

      {active && (
        <button type="button" className="tile" data-noev style={{ background: 'var(--butter)', borderColor: 'var(--butter-line)' }} onClick={() => go({ name: 'order', orderId: active.publicId })}>
          <Flower fill="#FAFBF6" size={36} />
          <span className="stack s6" style={{ gap: 2, flex: 1 }}>
            <span className="label">{active.kind === 'surprise' ? 'Сюрприз' : active.kind === 'individual' ? 'Индивидуальный букет' : active.designName}, {active.size}</span>
            <span className="small" style={{ color: 'var(--ink-2)' }}>{active.statusText}</span>
          </span>
          <Icon name="next" size={18} />
        </button>
      )}

      {me?.promos.some((p) => p.kind === 'individual') && (
        <button type="button" className="promo" onClick={() => go({ name: 'individual' })}>
          <Flower fill="#F7ACD6" center="#FCE3F0" size={30} />
          <span className="stack s6" style={{ gap: 1, flex: 1 }}>
            <span style={{ fontSize: 15, fontWeight: 600 }}>Индивидуальный букет</span>
            <span className="tiny" style={{ color: 'var(--pink-ink-2)' }}>
              Твой подарок: флорист соберёт букет L специально под тебя
            </span>
          </span>
          <Icon name="next" size={18} color="#8A2F5F" />
        </button>
      )}

      <div className="stack" style={{ gap: 12 }}>
        <p className="label" style={{ margin: '8px 0 0' }}>
          Для кого букет?
        </p>
        <button
          type="button"
          className="tile"
          style={{ background: 'var(--butter)', border: 'none', borderRadius: 28, padding: 20, minHeight: 104, gap: 16 }}
          onClick={() => {
            haptic.tap();
            startFlow('self');
            go({ name: 'when' });
          }}
        >
          <svg aria-hidden="true" viewBox="0 0 64 64" width="64" height="64">
            <path d="M22 40h20l-3 18H25z" fill="#FAFBF6" />
            <path d="M32 40V26" stroke="#8FA86E" strokeWidth="2.5" fill="none" />
            <path d="M32 34c5-1 8-4 9-8-5 0-8 3-9 8z" fill="#A9BF8A" />
            <g fill="#F7ACD6">
              <circle cx="32" cy="14" r="5" />
              <circle cx="37.7" cy="18.2" r="5" />
              <circle cx="35.5" cy="24.9" r="5" />
              <circle cx="28.5" cy="24.9" r="5" />
              <circle cx="26.3" cy="18.2" r="5" />
            </g>
            <circle cx="32" cy="20" r="4" fill="#FEEB9E" stroke="#FAFBF6" strokeWidth="1.5" />
          </svg>
          <span className="stack s6" style={{ gap: 4 }}>
            <span className="h2">Для себя или дома</span>
            <span style={{ fontSize: 14, color: 'var(--ink-2)' }}>Подберём по твоему вкусу</span>
          </span>
        </button>
        <button
          type="button"
          className="tile"
          style={{ background: 'var(--pink)', border: 'none', borderRadius: 28, padding: 20, minHeight: 104, gap: 16 }}
          onClick={() => {
            haptic.tap();
            startFlow('gift');
            go({ name: 'giftWho' });
          }}
        >
          <svg aria-hidden="true" viewBox="0 0 64 64" width="64" height="64">
            <rect x="14" y="30" width="36" height="26" rx="6" fill="#FAFBF6" />
            <rect x="29" y="30" width="6" height="26" fill="#F7ACD6" />
            <path d="M32 30c-6-8-14-6-12-1 1 3 7 3 12 1zM32 30c6-8 14-6 12-1-1 3-7 3-12 1z" fill="#E58FBF" />
            <rect x="11" y="24" width="42" height="8" rx="4" fill="#FAFBF6" />
          </svg>
          <span className="stack s6" style={{ gap: 4 }}>
            <span className="h2">В подарок</span>
            <span style={{ fontSize: 14, color: 'var(--pink-ink-2)' }}>Учтём повод и вкус получателя</span>
          </span>
        </button>
      </div>

      <div className="stack" style={{ alignItems: 'center', gap: 6 }}>
        {!onSite && <button type="button" className="btn light" style={{ alignSelf: 'stretch' }} onClick={() => go({ name: 'dates' })}>
          <svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#8A7A4A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="4" y="5" width="16" height="15" rx="3" />
            <path d="M4 10h16M9 3v4M15 3v4" />
            <circle cx="12" cy="15" r="1.4" fill="#F7ACD6" stroke="none" />
          </svg>
          Напомнить о важной дате
        </button>}
        <button type="button" className="quiet" style={{ textDecoration: 'underline', fontSize: 14 }} onClick={() => go({ name: 'catalog' })}>
          Хочу выбрать сам
        </button>
      </div>

      <div className="row small" style={{ marginTop: 'auto', justifyContent: 'center', gap: 8 }}>
        <Icon name="clock" size={16} width={1.8} />
        <span>Займёт около минуты</span>
      </div>

      {needConsent && (
        <ConsentSheet
          onDone={async () => {
            await reloadMe();
            setShowConsent(false);
          }}
          onSkip={() => {
            consentDismissed = true;
            setShowConsent(false);
          }}
        />
      )}
    </main>
  );
}

export function ConsentSheet({ onDone, onSkip }: { onDone: () => void; onSkip?: () => void }) {
  const { go } = useApp();
  const [pd, setPd] = useState(false);
  const [ads, setAds] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  return (
    <Sheet label="Согласия" onClose={onSkip}>
      <h2 className="h2">Пара слов перед стартом</h2>
      <p className="small" style={{ margin: 0 }}>
        Чтобы запомнить твой вкус и не спрашивать заново, мы сохраняем ответы и данные твоего профиля в Telegram.
      </p>
      <div className="card stack s6">
        <label className="check">
          <input type="checkbox" checked={pd} onChange={(e) => setPd(e.target.checked)} />
          <span>
            Даю согласие на обработку персональных данных
            <br />
            <button type="button" className="link tiny" onClick={() => go({ name: 'docs' })}>
              Текст согласия
            </button>
          </span>
        </label>
      </div>
      <div className="card stack s6">
        <label className="check">
          <input type="checkbox" checked={ads} onChange={(e) => setAds(e.target.checked)} />
          <span>
            Хочу получать напоминания о важных датах и подборки
            <br />
            <span className="tiny">Необязательно. Отключить можно в любой момент.</span>
          </span>
        </label>
      </div>
      <ErrorNote error={error} />
      <button
        type="button"
        className="btn"
        disabled={!pd || busy}
        onClick={async () => {
          setBusy(true);
          try {
            await api.consent(ads);
            track('consent_answered', { pd: true, ads });
            onDone();
          } catch (e: any) {
            setError(e.message);
          } finally {
            setBusy(false);
          }
        }}
      >
        Начать
      </button>
      {onSkip && (
        <button type="button" className="quiet" style={{ textDecoration: 'underline', fontSize: 13 }} onClick={() => (track('consent_answered', { pd: false, ads: false }), onSkip())}>
          Познакомимся позже
        </button>
      )}
    </Sheet>
  );
}

const WHO = [
  { rel: 'mom', label: 'Маме', name: 'Мама' },
  { rel: 'love', label: 'Любимым', name: 'Любимый человек' },
  { rel: 'friend', label: 'Подруге или другу', name: 'Друг' },
  { rel: 'work', label: 'Коллеге', name: 'Коллега' },
];

export function GiftWho() {
  const { go, flow, setFlow, me } = useApp();
  const [other, setOther] = useState(flow.relation === 'other' ? flow.personName ?? '' : '');
  const choose = (p: { personId?: number | null; personName: string; relation: string }) => {
    haptic.pick();
    setFlow({ personId: p.personId ?? null, personName: p.personName, relation: p.relation });
  };
  const ok = flow.relation && (flow.relation !== 'other' || other.trim());
  return (
    <main className="screen">
      <StepTop step={1} total={5} gift />
      <h1 className="h1">Кому дарим?</h1>
      {me && me.people.length > 0 && (
        <div className="stack s6">
          <span className="small">Твои люди</span>
          <div className="wrap">
            {me.people.map((p) => (
              <button key={p.id} type="button" className="chip pink" data-noev aria-pressed={flow.personId === p.id} onClick={() => choose({ personId: p.id, personName: p.name, relation: p.relation })}>
                {p.name}
              </button>
            ))}
          </div>
          <span className="small" style={{ marginTop: 8 }}>
            Или выбери
          </span>
        </div>
      )}
      <div className="grid2">
        {WHO.map((w) => (
          <button key={w.rel} type="button" className="tile pink" style={{ minHeight: 60 }} aria-pressed={!flow.personId && flow.relation === w.rel} onClick={() => choose({ personName: w.name, relation: w.rel })}>
            <span style={{ fontSize: 16 }}>{w.label}</span>
          </button>
        ))}
      </div>
      <button type="button" className="tile pink" aria-pressed={flow.relation === 'other'} onClick={() => choose({ personName: other, relation: 'other' })}>
        Другому человеку
      </button>
      {flow.relation === 'other' && (
        <label className="field">
          <span>Как зовут</span>
          <input className="input" autoFocus value={other} maxLength={60} placeholder="Например, Аня" onChange={(e) => (setOther(e.target.value), setFlow({ personName: e.target.value }))} />
        </label>
      )}
      <div className="bottom">
        <button type="button" className="btn" disabled={!ok} onClick={() => (track('gift_recipient_chosen', { relation: flow.relation, known_person: Boolean(flow.personId) }), go({ name: 'giftOccasion' }))}>
          Дальше
        </button>
      </div>
    </main>
  );
}

const OCCASIONS = [
  ['birthday', 'День рождения'],
  ['love', 'Годовщина, романтика'],
  ['thanks', 'Сказать спасибо'],
  ['sorry', 'Хочу извиниться'],
  ['just', 'Просто так'],
] as const;

export function GiftOccasion() {
  const { go, flow, setFlow } = useApp();
  return (
    <main className="screen">
      <StepTop step={2} total={5} gift />
      <div className="stack s6">
        <span className="eyebrow">{flow.relation === 'mom' ? 'Для мамы' : flow.personName ? `Подарок · ${flow.personName}` : 'В подарок'}</span>
        <h1 className="h1">Какой повод?</h1>
      </div>
      <div className="wrap" style={{ gap: 10 }}>
        {OCCASIONS.map(([id, label]) => (
          <button key={id} type="button" className="chip pink" style={{ minHeight: 48, fontSize: 15, padding: '0 16px' }} aria-pressed={flow.occasion === id} onClick={() => (haptic.pick(), setFlow({ occasion: id }))}>
            {label}
          </button>
        ))}
      </div>
      <div className="bottom">
        <button type="button" className="btn" disabled={!flow.occasion} onClick={() => (track('gift_occasion_chosen', { occasion: flow.occasion }), go({ name: 'when' }))}>
          Дальше
        </button>
      </div>
    </main>
  );
}

